<template>
  <v-dialog v-model="showMsg"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>مشاهده پیام</v-card-subtitle>
        <v-spacer/>

        <v-card-text>


          <v-form ref="form" lazy-validation v-model="valid">
            <v-row>
              <v-col cols="12" md="6">
                <label><span style="color: black">عنوان پیام:</span> {{ model.title }}</label>

              </v-col>
              <v-col cols="12"
                     md="12">
                <v-card-text>
                  <span>متن پیام:</span>
                  <br/>
                  <span style="text-align: right">{{ model.text }}</span>
                </v-card-text>


              </v-col>
            </v-row>
            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  small
                  depressed
                  color="error"
                  class=" pr-4 pl-4 m-1"
                  @click="closed"
              >
                بستن
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>

export default {

  props: {
    showMsg: {
      default: false,
    },
    model: Object,
  },
  data() {
    return {
      valid: true,

    }
  },

  methods: {
    closed() {
      this.$root.$emit('Message')
      this.$root.$emit('NavBar')
      this.$emit('update:showMsg', false)
    },
  },


}
</script>


